import { render, staticRenderFns } from "./UpdateAppointmentStatus.vue?vue&type=template&id=974ab45e"
import script from "./UpdateAppointmentStatus.vue?vue&type=script&lang=js"
export * from "./UpdateAppointmentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports